//export const colorPalette = ["#fd7f6f", "#7eb0d5", "#b2e061", "#bd7ebe", "#ffb55a", "#ffee65", "#beb9db", "#fdcce5", "#8bd3c7", "#ffee65", "#beb9db", "#fdcce5", "#8bd3c7", "#003f5c", "#2f4b7c", "#665191", "#d45087", "#7aa6c2", "#9dc6e0", "#c1e7ff"];
export const colorPalette = [
    '#fd7f6f', '#7eb0d5', '#b2e061', '#bd7ebe',
    '#ffb55a', '#ffee65', '#beb9db', '#fdcce5',
    '#8bd3c7', '#ffee65', '#beb9db', '#8bd3c7',
    '#7aa6c2', '#7FFF00', '#c1e7ff', '#FFFF00',
    '#ADFF2F', '#9dc6e0', '#00FF7F', '#3CB371',
    '#40E0D0', '#00CED1', '#1E90FF', '#6495ED',
    '#4682B4', '#5F9EA0', '#B0C4DE', '#ADD8E6',
    '#87CEEB', '#87CEFA', '#00BFFF', '#66CDAA',
    '#FF69B4', '#FFB6C1', '#FFC0CB', '#90EE90',
    '#00FF00', '#EE82EE', '#00FFFF', '#DA70D6',
    '#FF6347', '#FF4500', '#FF7F50', '#CD5C5C',
    '#FA8072', '#E9967A', '#F08080', '#DC143C',
    '#D87093', '#FF00FF', '#FF1493', '#DB7093',
    '#483D8B', '#6A5ACD', '#7B68EE', '#9370DB',
    '#8A2BE2', '#9400D3', '#9932CC', '#8B008B',
    '#FF00FF', '#808080', '#FFA500', '#800080',
    '#008000', '#FFD700', '#0000FF', '#d45087',
    '#800080', '#4B0082', '#3CB371', '#800000',
    '#003f5c', '#2f4b7c', '#665191', '#C71585',
    '#191970', '#FF0000', '#B22222', '#A52A2A',
    '#8B4513', '#000080',
];

export const defaultLegendItemCountToShow = 10;
export const colorPalettePie = ["#39B84D", "#fff"];
